import React, { useState } from 'react';
import { Table, Button, Modal } from 'react-bootstrap';
import { formatterPeso } from 'src/utils/utils';
import ActionIcon from 'src/components/general/ActionIcon';
import { faSearch, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BeneficiariesTable = (props) => {

    const [showPayOrderDetailModal, setShowPayOrderDetailModal] = useState(false);
    const [data, setData] = useState('');

    const {
        hookFormMethodsModal: { handleSubmit } = {},
    } = props?._hookFormMethodsModal || {};

    const handleModal = (item) => {
        setData(item);
        setShowPayOrderDetailModal(true);
    };

    const beneficiaries = props?.orderPayDetailData?.beneficiaries || [];
    const totalAmount = beneficiaries.reduce((sum, item) => sum + (item?.subsidyAmount || 0), 0);

    return <>
        <div className="col-md-6">
            <h5 className="card-title mb-3">
                <FontAwesomeIcon icon={faUsers} className=" mr-3 text-primary" />
                {beneficiaries.length} beneficiario{beneficiaries.length !== 1 ? 's' : ''}
            </h5>
        </div>
        <div className="card shadow-sm">
            <div className="card-body p-0">
                {beneficiaries.length === 0 ? (
                    <div className="text-center py-5">
                        <FontAwesomeIcon icon={faUsers} size="3x" className="text-muted mb-3" />
                        <h5 className="text-muted">No hay beneficiarios registrados</h5>
                        <p className="text-muted mb-0">Los beneficiarios aparecerán aquí una vez que sean agregados.</p>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table striped hover className="mb-0">
                            <thead className="table-dark">
                                <tr>
                                    <th className="text-center align-middle">
                                        <div className="fw-bold">CUIT</div>
                                    </th>
                                    <th className="text-center align-middle">
                                        <div className="fw-bold">Denominación</div>
                                    </th>
                                    <th className="text-center align-middle">
                                        <div className="fw-bold">Importe</div>
                                    </th>
                                    <th className="text-center align-middle" style={{ minWidth: '120px' }}>
                                        <div className="fw-bold">Acciones</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {beneficiaries.map((item, i) => (
                                    <tr key={item?.id || i} className="align-middle">
                                        <td className="text-center">
                                            {item?.persona?.cuit || 'N/A'}
                                        </td>
                                        <td className="text-center align-middle">
                                            <div className="fw-semibold " >
                                                {item?.persona?.companyName || 'Sin nombre'}
                                            </div>
                                        </td>
                                        <td className="text-right align-middle">
                                            <span className="fw-semibold align-middle fs-6 fw-bold px-3 py-2">
                                                {formatterPeso.format(item?.subsidyAmount || 0)}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <div className="btn-group" role="group">
                                                <ActionIcon
                                                    size="sm"
                                                    toolTipText="Ver detalle"
                                                    icon={faSearch}
                                                    className="btn-outline-primary"
                                                    onClick={() => handleModal(item)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        </div>
        <div className="d-flex flex-column align-items-md-end mt-2">
            <small className="text-muted">Importe Total</small>
            <h4 className="mb-0 fw-bold">
                {formatterPeso.format(totalAmount)}
            </h4>
        </div>
        <Modal
            show={showPayOrderDetailModal}
            onHide={() => setShowPayOrderDetailModal(false)}
            dialogClassName="modal-xl"
            centered
        >
            <Modal.Header closeButton className="bg-light">
                <Modal.Title>
                    <FontAwesomeIcon icon={faUsers} className="mr-2" />
                    Detalle
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {data && (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card mb-3">
                                <div className="card-header bg-primary text-white">
                                    <h6 className="mb-0">Beneficiario</h6>
                                </div>
                                <div className="card-body">

                                    <div className="row mb-2">
                                        <div className="col-4"><strong>CUIT:</strong></div>
                                        <div className="col-8">{data.persona?.cuit || data.cuit || 'N/A'}</div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-4"><strong>Razón Social:</strong></div>
                                        <div className="col-8">{data.persona?.companyName || 'Sin nombre'}</div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-4"><strong>Tipo:</strong></div>
                                        <div className="col-8">
                                            <span className="badge">{data.type || 'N/A'}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-4"><strong>Validador:</strong></div>
                                        <div className="col-8">
                                            <span >
                                                {data.persona?.beneficiaryValidator || 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-4"><strong>Importe:</strong></div>
                                        <div className="col-8">
                                            <span className="fw-bold fs-5">
                                                {formatterPeso.format(data.subsidyAmount || 0)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                )}
                <div className="d-flex justify-content-end mt-4">
                    <Button
                        variant="outline-secondary"
                        size="lg"
                        onClick={() => setShowPayOrderDetailModal(false)}
                    >
                        Cerrar
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    </>
};

export default BeneficiariesTable;